module.exports = __webpack_public_path__ + "img/arrow_up.165b58bc.svg";